import { render } from "./RoundedButton.vue?vue&type=template&id=6fe93587"
import script from "./RoundedButton.vue?vue&type=script&lang=js"
export * from "./RoundedButton.vue?vue&type=script&lang=js"

import "./RoundedButton.vue?vue&type=style&index=0&id=6fe93587&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__